import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import NewsletterForm from '@/components/feature/NewsletterForm';
import SEOSchema from '@/components/feature/SEOSchema';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedProducts from './components/FeaturedProducts';
import BrandStory from './components/BrandStory';
import ArticleHighlights from './components/ArticleHighlights';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOSchema type="WebSite" data={{
        name: '久久精品',
        url: 'https://jiujiuboutique.com',
        description: '久久精品汇聚全球优质精选商品，以严苛品控与持久品质为核心，为您甄选每一件经得起时间考验的精品。',
        inLanguage: 'zh-CN',
      }} />
      <SEOSchema type="Organization" data={{
        name: '久久精品',
        url: 'https://jiujiuboutique.com',
        description: '品质经久不衰的精选好物平台',
        email: 'hello@jiujiuboutique.com',
        telephone: '400-888-9999',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '南京西路1788号久久精品大厦15层',
          addressLocality: '上海',
          addressRegion: '上海',
          addressCountry: 'CN',
        },
      }} />
      <SEOSchema type="WebPage" data={{
        name: '久久精品——品质经久不衰的精选好物平台',
        description: '久久精品汇聚全球优质精选商品，覆盖家居、时尚、生活好物等品类，以严苛品控与持久品质为核心。',
        inLanguage: 'zh-CN',
        isPartOf: { '@type': 'WebSite', name: '久久精品', url: 'https://jiujiuboutique.com' },
      }} />

      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedProducts />
        <BrandStory />
        <ArticleHighlights />
        <NewsletterForm />
      </main>
      <Footer />
    </>
  );
}